<template>
  <Plotly :data='data' :layout='layout' :display-mode-bar='false'></Plotly>
</template>
<script>
import { Plotly } from 'vue-plotly'

export default {
  components: {
    Plotly
  },
  props: {
    title: String,
    datas: Array,
    layouts: Object
  },
  data () {
    return {
      data: this.datas,
      layout: this.layouts
    }
  },
  mounted () {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PlotlyAlternativeComponent.vue